import React, { useMemo } from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";
import IconButton from "./IconButton";

export type InfoButtonSize = "small" | "medium" | "large";

type InfoButtonProps = {
    onPress: () => void;
    style?: StyleProp<ViewStyle>;
    size?: InfoButtonSize;
};

const SIZE_MAP: Record<InfoButtonSize, number> = {
    small: 14,
    medium: 17,
    large: 24,
};

const InfoButton: React.FC<InfoButtonProps> = ({ onPress, style, size = "medium" }) => {
    const iconSize = SIZE_MAP[size];
    const { colors } = useTheme();
    const styles = useStyles();

    return (
        <IconButton
            hitSlop={20}
            icon="help-circle"
            iconColor={colors.greyAccessible}
            size={iconSize}
            style={[
                styles.iconButton,
                {
                    marginLeft: iconSize / 4,
                },
                style,
            ]}
            onPress={onPress}
        />
    );
};

const useStyles = () => {
    return useMemo(
        () =>
            StyleSheet.create({
                iconButton: {
                    position: "relative",
                    transform: [{ translateY: 2 }],
                },
            }),
        [],
    );
};

export default InfoButton;
